import AbstractBaseForm from '../hoc/form/AbstractBaseForm';
import _ from 'lodash';
import { TAB_STRIP_CHILD } from './Types';

export default abstract class TabStripChild<P = {}, S = {}> extends AbstractBaseForm<P & TAB_STRIP_CHILD, S> {
  /**
   * Return data
   */
  handleGetData = () => {
    const { getData } = this.props.form;
    const data = getData();

    return _.assign(data, this.getAdditionalData());
  }

  /**
   * An abstract method for getting data which can be overwritten in a child
   */
  getAdditionalData = () =>
    // getAdditionalData
    ({})

  /**
   * Set new data call setAdditionalData and getIsValidActiveChild which return are all fields valid
   * @param {any} data
   * @param {any} dynamicRules
   */
  handleSetData = (data: any, dynamicRules?: any) => {
    const { index, getIsValidActiveChild } = this.props;
    const { setData, isAllFieldValid } = this.props.form;

    this.setAdditionalData();
    setData(data, dynamicRules, () => getIsValidActiveChild(isAllFieldValid(), index));
  }

  /**
   * An abstract method for setting new data which can be overwritten in a child
   */
  setAdditionalData = () => {}

  componentDidMount() {
    const { index, getIsValidActiveChild, remoteChildren, data } = this.props;
    const { isAllFieldValid } = this.props.form;

    if (remoteChildren && data) {
      this.handleSetData(data);
    } else {
      getIsValidActiveChild(isAllFieldValid(), index);
    }
  }

  /**
   * Call getIsValidActiveChild to set new value for valid in state
   */
  onAllValidation = () => {
    const { index, getIsValidActiveChild } = this.props;
    const { isAllFieldValid } = this.props.form;
    const isValid = isAllFieldValid();
    getIsValidActiveChild(isValid, index);
  }
}
